import { useSettingsStore } from '@starsoft/common/hooks';
import { LinkProps } from './props';

/**
 * Link Component
 * A wrapper component that renders a router Link component based on the current settings.
 * Uses the router Link component defined in the settings store.
 * Returns null if no Link component is configured.
 *
 * @component
 * @param {LinkProps} props - Props to be passed to the underlying Link component
 * @returns {JSX.Element|null} The rendered Link component or null if not configured
 *
 * @example
 * // Basic usage with href
 * <Link href="/home">Home</Link>
 *
 * // With additional props
 * <Link
 *   href="/profile"
 *   className="nav-link"
 *   onClick={() => function('clicked')}
 * >
 *   Profile
 * </Link>
 */
export function Link(props: LinkProps) {
  const { state } = useSettingsStore();
  const Link = state.settings.router.Link;

  if (!Link) {
    return null;
  }

  return <Link {...props} />;
}
